module.exports = __webpack_public_path__ + "img/Modernisme_Norske_lyrikere6.e0fd2138.jpg";